import { render, staticRenderFns } from "./NotificationFollowings.vue?vue&type=template&id=6e989d0b&scoped=true&"
import script from "./NotificationFollowings.vue?vue&type=script&lang=ts&"
export * from "./NotificationFollowings.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationFollowings.vue?vue&type=style&index=0&id=6e989d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e989d0b",
  null
  
)

export default component.exports